import * as React from 'react';
import { Container } from '../../components/Container';
import { Button } from '../../components/Button';
import { Text } from '../../components/Text';
import { TextAndIcon } from '../../components/TextAndIcon';
import { Icon } from '../../components/Icon';
import { SIZE_12, SIZE_16, SIZE_332 } from '../../constants/sizes';
import { Clickable } from '../../components/Clickable';

export interface IMotivationPopupProps {
  onClose(): void;
}

export class MotivationPopup extends React.PureComponent<IMotivationPopupProps> {
  public render() {
    return (
      <Container
        backgroundColor="white"
        boxShadow="0 2px 8px 0 rgba(0, 0, 0, 0.25)"
        width={SIZE_332}
      >
        <Container
          display="flex"
          justifyContent="space-between"
          padding={`${SIZE_12} ${SIZE_16}`}
          backgroundColor="green_light"
        >
          <TextAndIcon
            iconType="check"
            fontWeight="bold"
            iconColor="green"
            iconColorHovered="green"
            reverse
          >
            Добавлено в избранное
          </TextAndIcon>
          <Container
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Clickable
              onClick={this.handleClosePopup}
            >
              <Icon
                type="close"
                color="gray_4"
                size={14}
              />
            </Clickable>
          </Container>
        </Container>
        <Container
          padding={`${SIZE_12} ${SIZE_16}`}
        >
          <Container>
            <Text>
              Войдите, для просмотра избранного с&nbsp;любого устройства
            </Text>
          </Container>
          <Container
            padding={`${SIZE_12} 0 0`}
          >
            <Button
              type="primary"
              onClick={this.handleClickLogin}
            >
              Войти
            </Button>
            <Button
              onClick={this.handleClickRegistration}
            >
              Зарегистрироваться
            </Button>
          </Container>
        </Container>
      </Container>
    );
  }

  private handleClickLogin = () => {
    this.handleClosePopup();

    if (window.waitForLoginPopup) {
      window.waitForLoginPopup();
    }
  }

  private handleClickRegistration = () => {
    this.handleClosePopup();

    if (window.waitForRegistrationPopup) {
      window.waitForRegistrationPopup();
    }
  }

  private handleClosePopup = () => {
    this.props.onClose();
  }
}
